import React from 'react';
import {coursePicker, showCertificate} from './';
import {Segment, Divider, Dimmer, Loader, Table} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {UserActions} from '../../actions';
import Moment from 'react-moment';

class Sertifikalar extends React.Component {
    constructor(props) {
        super(props);
        let drivers = this.props.driversBC;
        this.state = {
            drivers,
            certificate: 'Anti Skid',
        };
        
        if ( this.state.drivers === [] || !this.props.driversBCCreated) {
            
            this.props.dispatch(UserActions.get_drivers_bycertificate(this.state.certificate));
        }
        
        this.changeCPicker = this.changeCPicker.bind(this);
        this.openPopup = this.openPopup.bind(this);
    }
    openPopup(index) {
        if (this.props.driversBC != [] && this.props.driversBC[index].DriverId && this.props.driversBC[index].Certificate) {
            this.props.dispatch(UserActions.get_ucertificate(this.props.driversBC[index].DriverId, this.props.driversBC[index].Certificate));
        }
    }
    changeCPicker(event,data){
        this.setState({
            certificate: data.value,
        });
        this.props.dispatch(UserActions.get_drivers_bycertificate(data.value));
    }
    render() {
        return (
            <div>
                <Segment id='Egitimler' style={{ height: '50%' }}>
                    <div className='panel-pages-top' >
                        <h1 id='Egitimler'>Sertifikalar</h1>
                        {coursePicker.bind(this)()}
                    </div>          
                    <Divider />
                    <Segment id='Egitimler-ic'>
                        
                        {this.props.driversBCCreated &&
                            <Table id='antiSkid' textAlign='left' style={{background: 'rgba(255,255,255,0.12)'}}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Ad</Table.HeaderCell>
                                        <Table.HeaderCell>Soyad</Table.HeaderCell>
                                        <Table.HeaderCell>Tarih</Table.HeaderCell>
                                        <Table.HeaderCell>Sertifika</Table.HeaderCell>
                                        <Table.HeaderCell>Toplam Puan</Table.HeaderCell>
                                        <Table.HeaderCell>Goruntule</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                {getDrivers.bind(this)()}
                            </Table>
                        }
                        {this.props.driversBCCreating &&
                            <Dimmer active style={{background:'rgba(0,0,0,0)'}}>
                                <Loader />
                            </Dimmer>
                        }
                        
                    </Segment>
                </Segment>
            </div>


        );
    }
}
function getDrivers() {
    let drivers = this.props.driversBC;
    return drivers.map((driver,index ) => (
        <Table.Row>
            <Table.Cell>{driver.Name}</Table.Cell>
            <Table.Cell>{driver.Surname}</Table.Cell>
            <Table.Cell><Moment unix format = "DD/MM/YYYY">{driver.EvaluationDate/1000}</Moment></Table.Cell>
            <Table.Cell>{driver.Certificate}</Table.Cell>
            <Table.Cell>{driver.TotalPoint}</Table.Cell>
            <Table.Cell>{showCertificate.bind(this)(index, this.props.driversBC[index].Certificate)}</Table.Cell>
        </Table.Row>
    ));
}
function mapStateToProps(state) {
    const { driversBC, driversBCCreated, driversBCCreating } = state.driversBC;
    const { certificateDetails, detailsExists, detailsLoading } = state.certificateDetails;
    return {
        driversBC,
        driversBCCreated,
        driversBCCreating,
        certificateDetails,
        detailsExists,
        detailsLoading,
    };
}
const connectedCourses = connect(mapStateToProps)(Sertifikalar);
export { connectedCourses as Sertifikalar }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/Sertifikalar.jsx